export const LOAD_REPORT_REQUEST = "LOAD_REPORT_REQUEST";
export const LOAD_REPORT_SUCCESS = "LOAD_REPORT_SUCCESS";
export const LOAD_REPORT_FAILURE = "LOAD_REPORT_FAILURE";
export const RUN_REPORT_REQUEST = "RUN_REPORT_REQUEST";
export const RUN_REPORT_SUCCESS = "RUN_REPORT_SUCCESS";
export const RUN_REPORT_FAILURE = "RUN_REPORT_FAILURE";
export const GET_PARAM_VALUES_REQUEST = "GET_PARAM_VALUES_REQUEST";
export const GET_PARAM_VALUES_SUCCESS = "GET_PARAM_VALUES_SUCCESS";
export const GET_PARAM_VALUES_FAILURE = "GET_PARAM_VALUES_FAILURE";
export const SET_FILTER_DATA = "SET_FILTER_DATA";
